// Action Types
const OPEN_MODE = "spinner/OPEN_MODE";
const CLOSE_MODE = "spinner/CLOSE_MODE";

// Action Creators
export const openSpinner = (info) => ({ type: OPEN_MODE, info });
export const closeSpinner = (info) => ({ type: CLOSE_MODE, info });

// Initial
export const initialSpinnerState = {
    isShow: false,
    size: 60,
    color: "#8316e9",
    backdropColor: "transparent",
};

const spinnerState = { ...initialSpinnerState };

export default function spinnerReducer(state = spinnerState, action) {
    switch (action.type) {
        case OPEN_MODE:
            return {
                ...state,
                isShow: true,
                size: action?.info?.size || initialSpinnerState.size,
                color: action?.info?.color || initialSpinnerState.color,
                backdropColor: action?.info?.backdropColor || initialSpinnerState.backdropColor,
            };

        case CLOSE_MODE:
            return {
                state: initialSpinnerState,
            };
        default:
            return state;
    }
}
